import type { RefObject } from 'react'
import { useEffect, useState } from 'react'

export function useIntersection(
  ref: RefObject<HTMLElement | null>,
  options: IntersectionObserverInit,
): IntersectionObserverEntry | null {
  const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null)
  const { threshold, root, rootMargin } = options
  const element = ref.current

  useEffect(() => {
    if (!element || typeof IntersectionObserver !== 'function') {
      return
    }

    const observer = new IntersectionObserver(entries => setEntry(entries[0]), { threshold, root, rootMargin })
    observer.observe(element)

    return () => {
      setEntry(null)
      observer.disconnect()
    }
  }, [element, threshold, root, rootMargin])

  return entry
}
